import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateToThunk } from '../../core/navigation/navigationSlice.js';
import { showStepModalThunk } from './stepModalSlice.js';
import { dynamicMiddleware } from '../../index.js';
let stepModalNavigationMiddlewareInstance;
const stepModalNavigationMiddlewareOptions = {
    actionCreator: navigateToThunk.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        listenerApi.dispatch(showStepModalThunk(action.payload));
    },
};
const addStepModalNavigationMiddleware = () => {
    stepModalNavigationMiddlewareInstance = createListenerMiddleware();
    stepModalNavigationMiddlewareInstance.startListening(stepModalNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(stepModalNavigationMiddlewareInstance.middleware);
};
const removeStepModalNavigationMiddleware = () => {
    if (stepModalNavigationMiddlewareInstance) {
        dynamicMiddleware.removeMiddleware(stepModalNavigationMiddlewareInstance.middleware);
        stepModalNavigationMiddlewareInstance = null;
    }
};
export const stepModalNavigationMiddleware = {
    add: addStepModalNavigationMiddleware,
    remove: removeStepModalNavigationMiddleware,
};
//# sourceMappingURL=stepModalNavigationMiddleware.js.map